import React from 'react'
import LatestDealsContainer from 'containers/Deal/LatestDeals'

const LatestDealsPage = () => <LatestDealsContainer />

export default LatestDealsPage
